import {base} from "@wagmi/core/chains";
import {useAccount, useChainId, useSwitchChain} from 'wagmi';
import {useContext} from "react";
import {ToasterContext} from "../context-providers/ToasterProvider/ToasterProvider";

const switchChainMetaMask = async (requiredChainId: number) => {
    // this is where MetaMask lives
    const ethereum = (window as any).ethereum

    // check if MetaMask is available
    if (typeof ethereum === 'undefined') return

    try {
        // use the MetaMask RPC API to switch chains automatically
        await ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: `0x${requiredChainId.toString(16)}` }],
        })
    } catch (err) {
        console.warn("wallet_switchEthereumChain failed", err)
    }
}

export const useSwitchChainToBase = (): () => Promise<void> => {
    const switchUsingWagmi = useSwitchChainToBaseWagmi()
    const {connector} = useAccount()
    async function switchChainAsync(): Promise<void> {
        //if chain is unknown(not added to config) for wagmi the chainId is defined as polygon
        //but using RPC wallet_switchEthereumChain works only for MetaMask
        if (connector?.name === 'MetaMask') {
            await switchChainMetaMask(base.id)
        }
        await switchUsingWagmi()
    }

    return switchChainAsync
}


export const useSwitchChainToBaseWagmi = (): () => Promise<void> => {

    const chainId = useChainId();
    const { switchChain } = useSwitchChain();
    const { addToasterWithStatusAndDescription } = useContext(ToasterContext);

    async function switchChainAsync(): Promise<void> {
        //if switchChain called with polygonId when chainId is already Polygon the callbacks are not called, even onSettled
        if (chainId === base.id) {
            return
        }
        return new Promise((resolve, reject) => {
            switchChain({chainId: base.id}, {
                onSuccess: () => resolve(),
                onError: () => {
                    addToasterWithStatusAndDescription({
                        id: Date.now().toString(),
                        status: 'error',
                        title: 'Chain Switch',
                        description: 'Failed to switch on Polygon chain',
                        closeTime: 10000
                    })
                    reject()
                }
            })
        })
    }

    return switchChainAsync
}